import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useUsageTracking } from '../hooks/useUsageTracking';
import { Zap, Lock } from 'lucide-react';
import SubscriptionManager from './SubscriptionManager';

const UsageDisplay = ({ onUpgrade }) => {
  const { isOnFreeTier, isInTrial, getTrialDaysRemaining } = useUsageTracking();
  const [showSubscriptionManager, setShowSubscriptionManager] = useState(false);

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      setShowSubscriptionManager(true);
    }
  };

  if (!isOnFreeTier) {
    return null; // Don't show usage for paid users
  }

  // Show trial status if in trial
  if (isInTrial) {
    const daysRemaining = getTrialDaysRemaining;
    const isNearEnd = daysRemaining <= 2;
    const isAtEnd = daysRemaining === 0;

    return (
      <>
        <div
          className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm ${
            isAtEnd
              ? 'bg-red-50 text-red-700 border border-red-200'
              : isNearEnd
                ? 'bg-yellow-50 text-yellow-700 border border-yellow-200'
                : 'bg-green-50 text-green-700 border border-green-200'
          }`}
        >
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <Zap className="h-4 w-4 flex-shrink-0" />
            <span className="truncate">
              {isAtEnd
                ? 'Trial ended - upgrade for unlimited access'
                : `${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} left in your free trial`}
            </span>
          </div>
          <button
            onClick={handleUpgrade}
            className={`px-3 py-1 rounded text-xs font-medium transition-colors flex-shrink-0 ${
              isAtEnd
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-green-600 text-white hover:bg-green-700'
            }`}
          >
            {isAtEnd ? 'Upgrade Now' : 'Upgrade'}
          </button>
        </div>

        {/* Subscription Manager Modal */}
        {showSubscriptionManager && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <SubscriptionManager
                onClose={() => setShowSubscriptionManager(false)}
              />
            </div>
          </div>
        )}
      </>
    );
  }

  // Show trial expired message
  return (
    <>
      <div className="flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <Lock className="h-4 w-4 flex-shrink-0" />
          <span className="truncate">
            Trial ended - upgrade to continue using the app
          </span>
        </div>
        <button
          onClick={handleUpgrade}
          className="px-3 py-1 rounded text-xs font-medium transition-colors flex-shrink-0 bg-red-600 text-white hover:bg-red-700"
        >
          Upgrade Now
        </button>
      </div>

      {/* Subscription Manager Modal */}
      {showSubscriptionManager && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <SubscriptionManager
              onClose={() => setShowSubscriptionManager(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};

UsageDisplay.propTypes = {
  onUpgrade: PropTypes.func
};

export default UsageDisplay;
